import { sqrt } from "../math.js";
var tan30 = sqrt(1 / 3);
var tan30_2 = tan30 * 2;
export default {
  draw: function draw(context, size) {
    var y = sqrt(size / tan30_2);
    var x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
};